import { getEnv } from '@/utils/envs';

export const generateAPIUrl = (relativePath: string) => {
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  const apiBaseUrl =
    getEnv('EXPO_PUBLIC_API_BASE_URL') || process.env.EXPO_PUBLIC_API_BASE_URL;

  if (!apiBaseUrl) {
    throw new Error(
      'Please provide EXPO_PUBLIC_API_BASE_URL environment variable'
    );
  }

  const baseURL = apiBaseUrl;

  return baseURL.concat(path);
};

export const generateRedirectUrl = (path: string) => {
  return getEnv('EXPO_PUBLIC_API_BASE_URL')! + path;
};
